<template>
  <div class="rsvp-report-box">
    <div class="rsvp-report">
      <div class="form-group">
        <div class="instruction">Please select a date:</div>
        <div class="row expanded">
          <div class="small-12 column padding-R">
            <div class="date-input">
              <label>Start Date:</label>
              <datepicker class="datepicker" v-model="from" format="MMMM dd, yyyy"></datepicker>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="list-box">
      <div class="rsvp-report">
        <div class="form-group">
          <div class="instruction">Please select the reports to generate:</div>
          <div class="row expanded reports">
            <div :class="['small-12 column report', reportStatus.assigned, {'processing':loading}]">
              <label class="checkbox">
                <input type="checkbox" v-model="selectedReports.assigned" />
                <span>{{ reportLabel('assigned') }}</span>
              </label>
            </div>
          </div>
        </div>

        <transition name="slide-down">
          <div class="error" v-show="error.show">
            <span v-show="!!error.message">{{ error.message }}</span>
            <ul v-show="error.empty.length">
              <li>Empty Result:</li>
              <li v-for="(empty, ix) in error.empty" :key="ix">- {{ empty }}</li>
            </ul>
          </div>
        </transition>
        <a v-bind:class="{ 'button cta success small block': true, disabled: loading }"
          href="javascript:;" @click="generate">
          <i class="fa fa-spinner fa-spin" v-show="loading"></i>
          <span v-show="!loading">Generate and Download Report</span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
/* global CONFIG */
import moment from 'moment-timezone'
import datepicker from 'vuejs-datepicker'
import featureToggle from '@/modules/api/featureToggle'
import XLSX from 'xlsx'
import * as XlsxPopulate from 'xlsx-populate/browser/xlsx-populate'

export default {
  name: 'specialize-report',
  components: { datepicker },
  data () {
    return {
      from: null,
      error: {
        show: false,
        message: '',
        empty: []
      },
      selectedReports: {
        assigned: true,
      },
      reportStatus: {
        assigned: '',
      },
      loading: false,
      queue: [],
      assignedData: {
        list: {
          1: [],
          2: [],
          3: [],
          4: [],
          5: [],
          6: [],
          7: [],
        },
        loaded: 0
      },
      font: 'Calibri'
    }
  },
  computed: {
  },
  methods: {
    reportLabel (type) {
      switch (type) {
        case 'assigned': return 'Assigned Report'
      }
    },
    generate () {
      if (!this.isValid()) { return }

      for (let report in this.selectedReports) {
        if (this.selectedReports[report]) {
          this.reportStatus[report] = 'on-queue'
          this.queue.push(report)
        }
      }

      this.loading = true
      this.process()
    },
    isValid () {
      let self = this
      self.error.show = false
      self.error.empty = []
      if (self.from === null || self.to === null) {
        self.error.show = true
        self.error.message = 'Please specify the date.'
        return false
      }

      let from = moment(self.from)

      if (!self.selectedReports.assigned) {
        self.error.show = true
        self.error.message = 'Please select at least one report type.'
        return false
      }

      return true;
    },
    process () {
      if (!this.queue.length) {
        this.loading = false
        return
      }
      this.reportStatus[this.queue[0]] = 'loading'

      if (this.queue[0] === 'assigned') {
        this.assignedData.loaded = 0
        this.assignedData.list = {
          1: [],
          2: [],
          3: [],
          4: [],
          5: [],
          6: [],
          7: [],
        }
        this.getAssignedData()
        return
      }
    },
    getAssignedData () {
      let self = this
      if (self.assignedData.loaded == 7) {
        self.buildAssignedData()
        return
      }
      self.$sdk.get(`/reports/assigned/${self.assignedData.loaded + 1}`, {
        token: this.$store.state.session.sessionToken,
        since: moment(self.from).format('X')
      }, r => {
        if (!r.error) {
          self.assignedData.loaded += 1
          self.assignedData.list[self.assignedData.loaded] = r.data

          self.getAssignedData()
        } else {
          self.reportStatus.assigned = 'has-error'
          self.queue.shift()
          self.process()
          return
        }
      })
    },
    buildAssignedData () {
      let self = this

      let font = self.font
      XlsxPopulate.fromBlankAsync().then(workbook => {
        let sheetName = 'Assigned Reports'
        workbook.addSheet(sheetName)
        workbook.sheet(sheetName)
          .cell('A1')
          .style({fontSize: 22, fontFamily: font, bold: true, italic: true, verticalAlignment: 'center'})
          .value('OPOLI Reports')
        workbook.sheet(sheetName).range('A1:B1').merged(true)

        workbook.sheet(sheetName)
          .cell('A2')
          .style({fontSize: 16, fontFamily: font, bold: true, fontColor: '666666', verticalAlignment: 'center'})
          .value(`Date: ${moment(self.from).format('MM-DD-YYYY')}`)
        workbook.sheet(sheetName).range('A2:B2').merged(true)

        // Total Reservation
        workbook.sheet(sheetName)
          .cell('A5')
          .style({fontSize: 14, fontFamily: font, bold: true, fontColor: '434343', verticalAlignment: 'center'})
          .value('Total Reservations')
        workbook.sheet(sheetName).range('A5:B5').merged(true)
        workbook.sheet(sheetName).row('5').height(20)

        workbook.sheet(sheetName)
          .cell('A6')
          .style({fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black'})
          .value('Service Name')

        workbook.sheet(sheetName)
          .cell('B6')
          .style({fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black'})
          .value('RSVP')
        
        let currentRow = 7
        let total1 = 0
        if (self.assignedData.list[1].length) {
          self.assignedData.list[1].forEach(data => {
            workbook.sheet(sheetName)
              .cell(`A${currentRow}`)
              .style({fontSize: 9, fontFamily: font, horizontalAlignment: 'center', leftBorder: 'thin', borderColor: 'black'})
              .value(data.serviceName)
            workbook.sheet(sheetName)
              .cell(`B${currentRow}`)
              .style({fontSize: 9, fontFamily: font, horizontalAlignment: 'center', rightBorder: 'thin', borderColor: 'black'})
              .value(data.value)
            total1 += data.value
            currentRow++
          })
          workbook.sheet(sheetName)
            .cell(`A${currentRow}`)
            .style({fontSize: 11, fontFamily: font, bold: true, horizontalAlignment: 'center', leftBorder: 'thin', borderColor: 'black', bottomBorder: 'thin', topBorder: 'thin'})
            .value('Total')
          workbook.sheet(sheetName)
            .cell(`B${currentRow}`)
            .style({fontSize: 11, fontFamily: font, bold: true, horizontalAlignment: 'center', rightBorder: 'thin', borderColor: 'black', bottomBorder: 'thin', topBorder: 'thin'})
            .value(total1)
          workbook.sheet(sheetName).row(currentRow).height(18)
        } else {
          workbook.sheet(sheetName)
            .cell(`A${currentRow}`)
            .style({fontSize: 9, fontFamily: font, italic: true, fontColor: '777777', bold: true, horizontalAlignment: 'center', verticalAlignment: 'center', border: 'thin', borderColor: 'black'})
            .value('No reservation found.')
          workbook.sheet(sheetName).range(`A${currentRow}:B${currentRow}`).merged(true)
          workbook.sheet(sheetName).row(currentRow).height(25)
        }
        currentRow += 3

        // Assigned Reservations BEFORE 10AM
        workbook.sheet(sheetName)
          .cell(`A${currentRow}`)
          .style({fontSize: 14, fontFamily: font, bold: true, fontColor: '434343', verticalAlignment: 'center'})
          .value('Assigned Reservations BEFORE 10AM')
        workbook.sheet(sheetName).range(`A${currentRow}:B${currentRow}`).merged(true)
        workbook.sheet(sheetName).row(currentRow).height(20)
        currentRow++

        workbook.sheet(sheetName)
          .cell(`A${currentRow}`)
          .style({fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black'})
          .value('Service Name')

        workbook.sheet(sheetName)
          .cell(`B${currentRow}`)
          .style({fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black'})
          .value('RSVP')
        currentRow++
        
        let total2 = 0
        if (self.assignedData.list[2].length) {
          self.assignedData.list[2].forEach(data => {
            workbook.sheet(sheetName)
              .cell(`A${currentRow}`)
              .style({fontSize: 9, fontFamily: font, horizontalAlignment: 'center', leftBorder: 'thin', borderColor: 'black'})
              .value(data.serviceName)
            workbook.sheet(sheetName)
              .cell(`B${currentRow}`)
              .style({fontSize: 9, fontFamily: font, horizontalAlignment: 'center', rightBorder: 'thin', borderColor: 'black'})
              .value(data.value)
            total2 += data.value
            currentRow++
          })
          workbook.sheet(sheetName)
            .cell(`A${currentRow}`)
            .style({fontSize: 11, fontFamily: font, bold: true, horizontalAlignment: 'center', leftBorder: 'thin', borderColor: 'black', bottomBorder: 'thin', topBorder: 'thin'})
            .value('Assigned')
          workbook.sheet(sheetName)
            .cell(`B${currentRow}`)
            .style({fontSize: 11, fontFamily: font, bold: true, horizontalAlignment: 'center', rightBorder: 'thin', borderColor: 'black', bottomBorder: 'thin', topBorder: 'thin'})
            .value(total2)
          workbook.sheet(sheetName).row(currentRow).height(18)
        } else {
          workbook.sheet(sheetName)
            .cell(`A${currentRow}`)
            .style({fontSize: 9, fontFamily: font, italic: true, fontColor: '777777', bold: true, horizontalAlignment: 'center', verticalAlignment: 'center', border: 'thin', borderColor: 'black'})
            .value('No assigned reservation found.')
          workbook.sheet(sheetName).range(`A${currentRow}:B${currentRow}`).merged(true)
          workbook.sheet(sheetName).row(currentRow).height(25)
        }
        currentRow += 3

        // Assigned Reservations AFTER 10AM
        workbook.sheet(sheetName)
          .cell(`A${currentRow}`)
          .style({fontSize: 14, fontFamily: font, bold: true, fontColor: '434343', verticalAlignment: 'center'})
          .value('Assigned Reservations AFTER 10AM')
        workbook.sheet(sheetName).range(`A${currentRow}:B${currentRow}`).merged(true)
        workbook.sheet(sheetName).row(currentRow).height(20)
        currentRow++

        workbook.sheet(sheetName)
          .cell(`A${currentRow}`)
          .style({fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black'})
          .value('Service Name')

        workbook.sheet(sheetName)
          .cell(`B${currentRow}`)
          .style({fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black'})
          .value('RSVP')
        currentRow++
        
        let total3 = 0
        if (self.assignedData.list[3].length) {
          self.assignedData.list[3].forEach(data => {
            workbook.sheet(sheetName)
              .cell(`A${currentRow}`)
              .style({fontSize: 9, fontFamily: font, horizontalAlignment: 'center', leftBorder: 'thin', borderColor: 'black'})
              .value(data.serviceName)
            workbook.sheet(sheetName)
              .cell(`B${currentRow}`)
              .style({fontSize: 9, fontFamily: font, horizontalAlignment: 'center', rightBorder: 'thin', borderColor: 'black'})
              .value(data.value)
            total3 += data.value
            currentRow++
          })
          workbook.sheet(sheetName)
            .cell(`A${currentRow}`)
            .style({fontSize: 11, fontFamily: font, bold: true, horizontalAlignment: 'center', leftBorder: 'thin', borderColor: 'black', bottomBorder: 'thin', topBorder: 'thin'})
            .value('Assigned')
          workbook.sheet(sheetName)
            .cell(`B${currentRow}`)
            .style({fontSize: 11, fontFamily: font, bold: true, horizontalAlignment: 'center', rightBorder: 'thin', borderColor: 'black', bottomBorder: 'thin', topBorder: 'thin'})
            .value(total3)
          workbook.sheet(sheetName).row(currentRow).height(18)
        } else {
          workbook.sheet(sheetName)
            .cell(`A${currentRow}`)
            .style({fontSize: 9, fontFamily: font, italic: true, fontColor: '777777', bold: true, horizontalAlignment: 'center', verticalAlignment: 'center', border: 'thin', borderColor: 'black'})
            .value('No assigned reservation found.')
          workbook.sheet(sheetName).range(`A${currentRow}:B${currentRow}`).merged(true)
          workbook.sheet(sheetName).row(currentRow).height(25)
        }
        currentRow += 3

        // Not assigned Reservations BEFORE 10AM
        workbook.sheet(sheetName)
          .cell(`A${currentRow}`)
          .style({fontSize: 14, fontFamily: font, bold: true, fontColor: '434343', verticalAlignment: 'center'})
          .value('Not assigned Reservations BEFORE 10AM')
        workbook.sheet(sheetName).range(`A${currentRow}:B${currentRow}`).merged(true)
        workbook.sheet(sheetName).row(currentRow).height(20)
        currentRow++

        workbook.sheet(sheetName)
          .cell(`A${currentRow}`)
          .style({fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black'})
          .value('Service Name')

        workbook.sheet(sheetName)
          .cell(`B${currentRow}`)
          .style({fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black'})
          .value('RSVP')
        currentRow++
        
        let total4 = 0
        if (self.assignedData.list[4].length) {
          self.assignedData.list[4].forEach(data => {
            workbook.sheet(sheetName)
              .cell(`A${currentRow}`)
              .style({fontSize: 9, fontFamily: font, horizontalAlignment: 'center', leftBorder: 'thin', borderColor: 'black'})
              .value(data.serviceName)
            workbook.sheet(sheetName)
              .cell(`B${currentRow}`)
              .style({fontSize: 9, fontFamily: font, horizontalAlignment: 'center', rightBorder: 'thin', borderColor: 'black'})
              .value(data.value)
            total4 += data.value
            currentRow++
          })
          workbook.sheet(sheetName)
            .cell(`A${currentRow}`)
            .style({fontSize: 11, fontFamily: font, bold: true, horizontalAlignment: 'center', leftBorder: 'thin', borderColor: 'black', bottomBorder: 'thin', topBorder: 'thin'})
            .value('Not assigned')
          workbook.sheet(sheetName)
            .cell(`B${currentRow}`)
            .style({fontSize: 11, fontFamily: font, bold: true, horizontalAlignment: 'center', rightBorder: 'thin', borderColor: 'black', bottomBorder: 'thin', topBorder: 'thin'})
            .value(total4)
          workbook.sheet(sheetName).row(currentRow).height(18)
        } else {
          workbook.sheet(sheetName)
            .cell(`A${currentRow}`)
            .style({fontSize: 9, fontFamily: font, italic: true, fontColor: '777777', bold: true, horizontalAlignment: 'center', verticalAlignment: 'center', border: 'thin', borderColor: 'black'})
            .value('No reservation found.')
          workbook.sheet(sheetName).range(`A${currentRow}:B${currentRow}`).merged(true)
          workbook.sheet(sheetName).row(currentRow).height(25)
        }
        currentRow += 3

        // Not assigned Reservations AFTER 10AM
        workbook.sheet(sheetName)
          .cell(`A${currentRow}`)
          .style({fontSize: 14, fontFamily: font, bold: true, fontColor: '434343', verticalAlignment: 'center'})
          .value('Not assigned Reservations AFTER 10AM')
        workbook.sheet(sheetName).range(`A${currentRow}:B${currentRow}`).merged(true)
        workbook.sheet(sheetName).row(currentRow).height(20)
        currentRow++

        workbook.sheet(sheetName)
          .cell(`A${currentRow}`)
          .style({fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black'})
          .value('Service Name')

        workbook.sheet(sheetName)
          .cell(`B${currentRow}`)
          .style({fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black'})
          .value('RSVP')
        currentRow++
        
        let total5 = 0
        if (self.assignedData.list[5].length) {
          self.assignedData.list[5].forEach(data => {
            workbook.sheet(sheetName)
              .cell(`A${currentRow}`)
              .style({fontSize: 9, fontFamily: font, horizontalAlignment: 'center', leftBorder: 'thin', borderColor: 'black'})
              .value(data.serviceName)
            workbook.sheet(sheetName)
              .cell(`B${currentRow}`)
              .style({fontSize: 9, fontFamily: font, horizontalAlignment: 'center', rightBorder: 'thin', borderColor: 'black'})
              .value(data.value)
            total5 += data.value
            currentRow++
          })
          workbook.sheet(sheetName)
            .cell(`A${currentRow}`)
            .style({fontSize: 11, fontFamily: font, bold: true, horizontalAlignment: 'center', leftBorder: 'thin', borderColor: 'black', bottomBorder: 'thin', topBorder: 'thin'})
            .value('Not assigned')
          workbook.sheet(sheetName)
            .cell(`B${currentRow}`)
            .style({fontSize: 11, fontFamily: font, bold: true, horizontalAlignment: 'center', rightBorder: 'thin', borderColor: 'black', bottomBorder: 'thin', topBorder: 'thin'})
            .value(total5)
          workbook.sheet(sheetName).row(currentRow).height(18)
        } else {
          workbook.sheet(sheetName)
            .cell(`A${currentRow}`)
            .style({fontSize: 9, fontFamily: font, italic: true, fontColor: '777777', bold: true, horizontalAlignment: 'center', verticalAlignment: 'center', border: 'thin', borderColor: 'black'})
            .value('No reservation found.')
          workbook.sheet(sheetName).range(`A${currentRow}:B${currentRow}`).merged(true)
          workbook.sheet(sheetName).row(currentRow).height(25)
        }
        currentRow += 3

        // Available Drivers BEFORE 10AM
        workbook.sheet(sheetName)
          .cell(`A${currentRow}`)
          .style({fontSize: 14, fontFamily: font, bold: true, fontColor: '434343', verticalAlignment: 'center'})
          .value('Available Drivers BEFORE 10AM')
        workbook.sheet(sheetName).range(`A${currentRow}:C${currentRow}`).merged(true)
        workbook.sheet(sheetName).row(currentRow).height(20)
        currentRow++

        workbook.sheet(sheetName)
          .cell(`A${currentRow}`)
          .style({fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black'})
          .value('Service Name')

        workbook.sheet(sheetName)
          .cell(`B${currentRow}`)
          .style({fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black'})
          .value('Drivers')

        workbook.sheet(sheetName)
          .cell(`C${currentRow}`)
          .style({fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black'})
          .value('List')
        currentRow++
        
        let total6 = 0
        if (self.assignedData.list[6].length) {
          self.assignedData.list[6].forEach(data => {
            workbook.sheet(sheetName)
              .cell(`A${currentRow}`)
              .style({fontSize: 9, fontFamily: font, horizontalAlignment: 'center', leftBorder: 'thin', borderColor: 'black'})
              .value(data.serviceName)
            workbook.sheet(sheetName)
              .cell(`B${currentRow}`)
              .style({fontSize: 9, fontFamily: font, horizontalAlignment: 'center'})
              .value(data.driversAvailable)
            workbook.sheet(sheetName)
              .cell(`C${currentRow}`)
              .style({fontSize: 9, fontFamily: font, horizontalAlignment: 'center', rightBorder: 'thin', borderColor: 'black'})
              .value(data.drivers.join(", "))
            total6 += data.driversAvailable
            currentRow++
          })
          workbook.sheet(sheetName)
            .cell(`A${currentRow}`)
            .style({fontSize: 11, fontFamily: font, bold: true, horizontalAlignment: 'center', leftBorder: 'thin', borderColor: 'black', bottomBorder: 'thin', topBorder: 'thin'})
            .value('Available Drivers')
          workbook.sheet(sheetName)
            .cell(`B${currentRow}`)
            .style({fontSize: 11, fontFamily: font, bold: true, horizontalAlignment: 'center', borderColor: 'black', bottomBorder: 'thin', topBorder: 'thin'})
            .value(total6)
          workbook.sheet(sheetName)
            .cell(`C${currentRow}`)
            .style({fontSize: 11, fontFamily: font, bold: true, horizontalAlignment: 'center', rightBorder: 'thin', borderColor: 'black', bottomBorder: 'thin', topBorder: 'thin'})
            .value('')
          workbook.sheet(sheetName).row(currentRow).height(18)
        } else {
          workbook.sheet(sheetName)
            .cell(`A${currentRow}`)
            .style({fontSize: 9, fontFamily: font, italic: true, fontColor: '777777', bold: true, horizontalAlignment: 'center', verticalAlignment: 'center', border: 'thin', borderColor: 'black'})
            .value('No driver found.')
          workbook.sheet(sheetName).range(`A${currentRow}:C${currentRow}`).merged(true)
          workbook.sheet(sheetName).row(currentRow).height(25)
        }
        currentRow += 3

        // Available Drivers AFTER 10AM
        workbook.sheet(sheetName)
          .cell(`A${currentRow}`)
          .style({fontSize: 14, fontFamily: font, bold: true, fontColor: '434343', verticalAlignment: 'center'})
          .value('Available Drivers AFTER 10AM')
        workbook.sheet(sheetName).range(`A${currentRow}:C${currentRow}`).merged(true)
        workbook.sheet(sheetName).row(currentRow).height(20)
        currentRow++

        workbook.sheet(sheetName)
          .cell(`A${currentRow}`)
          .style({fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black'})
          .value('Service Name')

        workbook.sheet(sheetName)
          .cell(`B${currentRow}`)
          .style({fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black'})
          .value('Drivers')

        workbook.sheet(sheetName)
          .cell(`C${currentRow}`)
          .style({fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black'})
          .value('List')
        currentRow++
        
        let total7 = 0
        if (self.assignedData.list[7].length) {
          self.assignedData.list[7].forEach(data => {
            workbook.sheet(sheetName)
              .cell(`A${currentRow}`)
              .style({fontSize: 9, fontFamily: font, horizontalAlignment: 'center', leftBorder: 'thin', borderColor: 'black'})
              .value(data.serviceName)
            workbook.sheet(sheetName)
              .cell(`B${currentRow}`)
              .style({fontSize: 9, fontFamily: font, horizontalAlignment: 'center'})
              .value(data.driversAvailable)
            workbook.sheet(sheetName)
              .cell(`C${currentRow}`)
              .style({fontSize: 9, fontFamily: font, horizontalAlignment: 'center', rightBorder: 'thin', borderColor: 'black'})
              .value(data.drivers.join(", "))
            total7 += data.driversAvailable
            currentRow++
          })
          workbook.sheet(sheetName)
            .cell(`A${currentRow}`)
            .style({fontSize: 11, fontFamily: font, bold: true, horizontalAlignment: 'center', leftBorder: 'thin', borderColor: 'black', bottomBorder: 'thin', topBorder: 'thin'})
            .value('Available Drivers')
          workbook.sheet(sheetName)
            .cell(`B${currentRow}`)
            .style({fontSize: 11, fontFamily: font, bold: true, horizontalAlignment: 'center', borderColor: 'black', bottomBorder: 'thin', topBorder: 'thin'})
            .value(total7)
          workbook.sheet(sheetName)
            .cell(`C${currentRow}`)
            .style({fontSize: 11, fontFamily: font, bold: true, horizontalAlignment: 'center', rightBorder: 'thin', borderColor: 'black', bottomBorder: 'thin', topBorder: 'thin'})
            .value('')
          workbook.sheet(sheetName).row(currentRow).height(18)
        } else {
          workbook.sheet(sheetName)
            .cell(`A${currentRow}`)
            .style({fontSize: 9, fontFamily: font, italic: true, fontColor: '777777', bold: true, horizontalAlignment: 'center', verticalAlignment: 'center', border: 'thin', borderColor: 'black'})
            .value('No driver found.')
          workbook.sheet(sheetName).range(`A${currentRow}:C${currentRow}`).merged(true)
          workbook.sheet(sheetName).row(currentRow).height(25)
        }
        currentRow += 3
        
        workbook.sheet(sheetName).row('1').height(25)
        workbook.sheet(sheetName).row('2').height(20)
        workbook.sheet(sheetName).column('A').width(25)
        workbook.sheet(sheetName).column('B').width(25)
        workbook.sheet(sheetName).column('C').width(50)

        self.save(workbook)
      })
    },
    save (workbook) {
      let self = this
      let from = moment(self.from)
      let filename = `Opoli Assigned Report - ${from.format('MM-DD-YYYY')}.xlsx`

      // save the workbook
      workbook.deleteSheet('Sheet1')
      workbook.outputAsync().then(function (blob) {
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          // If IE, you must uses a different method.
          window.navigator.msSaveOrOpenBlob(blob, filename)
        } else {
          let url = window.URL.createObjectURL(blob)
          let a = document.createElement('a')
          document.body.appendChild(a)
          a.href = url
          a.download = filename
          a.click()
          window.URL.revokeObjectURL(url)
          document.body.removeChild(a)
        }
        self.queue.shift()
        self.process()
      })
    }
  },
  watch: {
  }
}
</script>

<style lang="scss" scoped>
.rsvp-report-box {
  transform-origin: top center;
  position: relative;
  width: 100%;
}
.rsvp-report {
  border-radius: 3px;
  padding: 0 20px 20px;

  & .title {
    text-align: center;
    font-weight: 700;
    margin-bottom: 20px;
    font-size: 18px;
  }

  & .date-input {
    margin-bottom: 10px;

    & label {
      font-size: 13px;
      color: #999;
      display: block;
    }
  }
  .reports{
    max-height: 350px;
    margin-bottom: 10px;
    overflow: auto;
    clear: both;
    background: #fafafa;
    border: 1px solid #ddd;
    position: relative;

    .report{
      position: relative;
      z-index: 1;

      &:hover{ background:#f1f1f1; }
      &.processing{
        background: rgba(0,0,0, .7);
        input{ opacity: .5; }
      }
      select{
        margin-left: 28px;
        margin-bottom: 10px;
        width: calc(100% - 43px);
        border-color: #999;
        font-size: 13px;
        color: #333;
        padding: 3px 5px;
        transition: all .2s ease;

        &.disabled{
          background: #fafafa;
          border-color: #ccc;
        }
        option:disabled{ background: #eaeaea; }
      }
      &.on-queue, &.loading, &.has-error, &.success{
        z-index: 3;
        box-shadow: 0 0 2px rgba(0,0,0, .4);
      }
      &.on-queue{ background: #fff; }
      &.loading{
        color: #775913;
        background: #f1ce7e;
      }
      &.success{
        color: #0f693a;
        background: #a9f7ce;
      }
      &.has-error{
        color: #b93030;
        background: #fbb0b0;
      }
    }
  }
}
.checkbox {
  display: block;
  font-size: 13px;
  cursor: pointer;
  padding: 5px 10px;
  & > * {
    display: inline-block;
    vertical-align: middle;
    margin: 0;
    width: auto;
  }
  input { margin-right: 3px; }
}
.padding-R { padding-right: 7px; }
.padding-L { padding-left: 7px; }
.error {
  background-color: #F25E0D;
  font-size: 14px;
  text-align: center;
  color: #fff;
  border-radius: 3px;
  padding: 5px;
  margin-bottom: 15px;
  transform-origin: top center;

  ul{
    list-style: none;
    margin: 0;
    padding: 10px;
    text-align: left;

    li:first-child{
      font-weight: 600;
      font-size: 14px;
      line-height: 1;
      margin-bottom: 2px;
    }
    li{
      font-size: 13px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Reports/BackendManager.vue